import { RequestStatus } from '../../constants/request';
import { TextLabel } from 'neon-design-system';
interface Props {
  status: RequestStatus;
}

export const RequestStatusLabel = ({ status }: Props) => {
  switch (status) {
    case RequestStatus.PENDING:
      return <TextLabel label="Pending" styleName="default" />;
    case RequestStatus.IN_PROGRESS:
      return <TextLabel label="In Progress" styleName="info" />;
    case RequestStatus.COMPLETE:
    case RequestStatus.COMPLETED:
      return <TextLabel label="Complete" styleName="success" />;
    case RequestStatus.REJECTED:
      return <TextLabel label="Rejected" styleName="error" />;
    case RequestStatus.CANCELLED:
      return <TextLabel label="Cancelled" styleName="error" />;
    default:
      return null;
  }
};
